import { useState } from 'react';

const Apply = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    city: '',
    experience: '',
    platforms: {
      stripChat: false,
      myDirtyHobby: false,
      other: ''
    },
    about: ''
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('platform_')) {
      const platform = name.replace('platform_', '');
      setFormData(prev => ({
        ...prev,
        platforms: {
          ...prev.platforms,
          [platform]: checked
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: value
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Hier kommt später die Formular-Verarbeitung
    console.log('Form submitted:', formData);
  };

  const benefits = [
    {
      text: "Top-Ausstattung: Laptop, Kamera, Licht und Toys inklusive.",
      icon: "✅"
    },
    {
      text: "Studio-Wohnnetzwerk: Wohnungen in ganz Deutschland – voll ausgestattet für Streaming.",
      icon: "✅"
    },
    {
      text: "Persönliche Betreuung: Wir sind immer an deiner Seite.",
      icon: "✅"
    },
    {
      text: "Flexible Plattformwahl: Du entscheidest, wo du streamst.",
      icon: "✅"
    }
  ];

  const steps = [
    {
      title: "Sichtung deiner Bewerbung",
      description: "Unser Team prüft deine Angaben und kontaktiert dich innerhalb von 48 Stunden."
    },
    {
      title: "Persönliches Gespräch",
      description: "Wir klären deine Fragen und besprechen die nächsten Schritte."
    },
    {
      title: "Dein Start",
      description: "Erhalte dein Starterpaket und beginne deine Reise mit Angel & Devil Network!"
    }
  ];

  return (
    <div className="pt-20 w-full">
      {/* Hero Section */}
      <section className="relative py-20 lg:py-32 overflow-hidden w-full">
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/95 to-deep-black -z-10"></div>
        <div className="absolute -top-1/2 right-0 w-3/4 h-full bg-gradient-to-bl from-hot-pink/20 to-accent-purple/20 blur-3xl animate-float"></div>
        <div className="absolute -bottom-1/2 left-0 w-3/4 h-full bg-gradient-to-tr from-neon-blue/20 to-hot-pink/20 blur-3xl animate-float" style={{ animationDelay: '-3s' }}></div>

        <div className="container-custom">
          <div className="max-w-none text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black mb-6">
              Bewirb dich – <span className="text-gradient">Werde Teil von uns</span>
            </h1>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-playfair mb-8">
              Where <span className="text-hot-pink">Temptation</span> Meets <span className="text-accent-purple">Talent</span>
            </h2>
            <p className="text-lg sm:text-xl text-white/80 mb-8 max-w-4xl mx-auto">
              Du bist bereit, deine Karriere in der Webcam-Branche zu starten oder auf das nächste Level zu bringen? 
              Bei Angel & Devil Network bekommst du alles, was du brauchst, um erfolgreich zu sein: Equipment, 
              Unterstützung und Zugang zu einem starken Netzwerk. Jetzt ist der perfekte Moment, um durchzustarten!
            </p>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 w-full bg-gradient-to-b from-deep-black to-deep-black/95">
        <div className="container-custom">
          <h2 className="text-3xl sm:text-4xl font-playfair text-center mb-12">
            Warum <span className="text-gradient">Angel & Devil Network</span>?
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="relative group">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-2xl blur opacity-25 group-hover:opacity-75 transition duration-300"></div>
                <div className="relative glass-effect rounded-xl p-6 h-full">
                  <div className="text-2xl mb-4">{benefit.icon}</div>
                  <p className="text-white/80">{benefit.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="py-20 w-full bg-gradient-to-b from-deep-black/95 to-deep-black">
        <div className="container-custom">
          <div className="grid grid-cols-1 xl:grid-cols-4 gap-8">
            {/* Form */}
            <div className="xl:col-span-3">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8">
                  <h2 className="text-2xl sm:text-3xl font-playfair text-gradient mb-8">Bewerbungsformular</h2>
                  <p className="text-lg text-white/80 mb-8">
                    Lass uns mehr über dich erfahren! Fülle das Formular aus und wir melden uns innerhalb von 48 Stunden bei dir.
                  </p>
                  <form onSubmit={handleSubmit} className="space-y-6">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label htmlFor="name" className="block text-white mb-2">Name</label>
                        <input
                          type="text"
                          id="name"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          required
                        />
                      </div>
                      <div>
                        <label htmlFor="email" className="block text-white mb-2">E-Mail-Adresse</label>
                        <input
                          type="email"
                          id="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          required
                        />
                      </div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div>
                        <label htmlFor="phone" className="block text-white mb-2">Telefonnummer</label>
                        <input
                          type="tel"
                          id="phone"
                          name="phone"
                          value={formData.phone}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          required
                        />
                      </div>
                      <div>
                        <label htmlFor="city" className="block text-white mb-2">Stadt/Region</label>
                        <input
                          type="text"
                          id="city"
                          name="city"
                          value={formData.city}
                          onChange={handleChange}
                          className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          required
                        />
                      </div>
                    </div>
                    <div>
                      <label className="block text-white mb-2">Hast du bereits Erfahrung als Webcam-Performer?</label>
                      <div className="space-y-2">
                        <label className="flex items-center space-x-3">
                          <input
                            type="radio"
                            name="experience"
                            value="yes"
                            checked={formData.experience === 'yes'}
                            onChange={handleChange}
                            className="form-radio text-hot-pink focus:ring-hot-pink"
                          />
                          <span className="text-white">Ja</span>
                        </label>
                        <label className="flex items-center space-x-3">
                          <input
                            type="radio"
                            name="experience"
                            value="no"
                            checked={formData.experience === 'no'}
                            onChange={handleChange}
                            className="form-radio text-hot-pink focus:ring-hot-pink"
                          />
                          <span className="text-white">Nein</span>
                        </label>
                      </div>
                    </div>
                    <div>
                      <label className="block text-white mb-2">Auf welchen Plattformen möchtest du arbeiten?</label>
                      <div className="space-y-2">
                        <label className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            name="platform_stripChat"
                            checked={formData.platforms.stripChat}
                            onChange={handleChange}
                            className="form-checkbox text-hot-pink focus:ring-hot-pink"
                          />
                          <span className="text-white">Strip-Chat</span>
                        </label>
                        <label className="flex items-center space-x-3">
                          <input
                            type="checkbox"
                            name="platform_myDirtyHobby"
                            checked={formData.platforms.myDirtyHobby}
                            onChange={handleChange}
                            className="form-checkbox text-hot-pink focus:ring-hot-pink"
                          />
                          <span className="text-white">myDirtyHobby</span>
                        </label>
                        <div className="mt-2">
                          <input
                            type="text"
                            name="platform_other"
                            value={formData.platforms.other}
                            onChange={handleChange}
                            placeholder="Andere Plattformen..."
                            className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                          />
                        </div>
                      </div>
                    </div>
                    <div>
                      <label htmlFor="about" className="block text-white mb-2">
                        Erzähl uns etwas über dich und deine Ziele (optional)
                      </label>
                      <textarea
                        id="about"
                        name="about"
                        value={formData.about}
                        onChange={handleChange}
                        rows="6"
                        className="w-full px-4 py-3 rounded-xl bg-deep-black/50 border border-white/10 focus:border-hot-pink focus:ring-1 focus:ring-hot-pink outline-none transition-colors"
                      ></textarea>
                    </div>
                    <button type="submit" className="btn-primary w-full text-lg">
                      Jetzt bewerben 🚀
                    </button>
                  </form>
                </div>
              </div>
            </div>

            {/* Steps */}
            <div className="space-y-8">
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8">
                  <h2 className="text-2xl font-playfair text-gradient mb-6">Wie geht es weiter?</h2>
                  <div className="space-y-6">
                    {steps.map((step, index) => (
                      <div key={index} className="flex items-start gap-4">
                        <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-to-r from-hot-pink to-accent-purple flex items-center justify-center text-white font-bold">
                          {index + 1}
                        </div>
                        <div>
                          <h3 className="text-white font-medium mb-1">{step.title}</h3>
                          <p className="text-white/80">{step.description}</p>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

              {/* Questions */}
              <div className="relative">
                <div className="absolute -inset-1 bg-gradient-to-r from-hot-pink to-accent-purple rounded-3xl blur opacity-25"></div>
                <div className="relative glass-effect rounded-2xl p-8">
                  <h2 className="text-2xl font-playfair text-gradient mb-4">Noch Fragen?</h2>
                  <p className="text-white/80 mb-4">
                    Kontaktiere uns unter{' '}
                    <a href="mailto:info@angel-devil.network" className="text-hot-pink hover:text-accent-purple transition-colors">
                      info@angel-devil.network
                    </a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Apply;
